import { render, staticRenderFns } from "./RentalObjectTenanciesView.vue?vue&type=template&id=03d58f80&"
import script from "./RentalObjectTenanciesView.vue?vue&type=script&lang=js&"
export * from "./RentalObjectTenanciesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports